import React, { useEffect } from "react";
import MdaeDrawer, { IMdaeDrawerOption } from "../drawer";
import { useSelector, useDispatch } from "react-redux";
import { Template } from "devextreme-react/core/template";
import { SET_MDAE_NAVIGATION_BAR_CONFIG } from "./reducers/mdae-navigation-bar-reducer";
import { actions } from "async-ops";
import $ from "jquery";
import "./index.scss";
import MdaeDrawerMenuListTemplate from "./mdae-drawer-menu-list-template";
import MdaeScrollView from "../scroll-view";
import { mdaeNewNavigationBarConfig } from "./mdae-navigation-bar-config";
import { useMemo } from "react";
import { isEqual } from "lodash";
import { GET_CURRENT_USER } from "./services/get-current-user";
import { GET_THOUGHT_SPOT_SETTINGS } from "./services/get-thought-spot-settings";
import { Cookie } from "../../../angular-app-handlers";
import pageCustomTitleBarConfig from "./mdae-custom-page-title-config";
import { TOGGLE_DASHBOARD_SETTING_POPUP } from "../../../pages/external-dashboard/reducers/ea-dashboard-reducer";
import { GET_APPLICATION_CONFIGURATIONS } from "./services/get-application-configurations";
import { FG_EXTERNAL_USER_TASK_EDITING, HOSPITAL_WORKFLOW, PROFESSIONAL_WORKFLOW, hasAnyFeatureGroupAccess, hasWorkflowAccess } from "../../user-permissions-helper";
import { GET_CLIENT_LIST } from "./services/get-client-list";

interface IMdaeNavigationProps {
  mdaePageContentLayoutHeight?: string;
  history?: any;
  isAnalyticsTheme?: any;
  isEatTheme?: any;
  children?: React.ReactNode;
}

const MdaeNavigationBar: React.FC<IMdaeNavigationProps> = (props) => {
  const dispatch = useDispatch();
  const mdaeNavigationBarListWidth = useSelector(
    (state) => state["mdaeNavigationBarReducer"].mdaeNavigationBarListWidth,
    isEqual
  );

  const mdaePageTitle = useSelector(
    (state) => state["mdaeNavigationBarReducer"].mdaePageTitle,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );
  const thoughtSpotSettings = useSelector(
    (state) => state["mdaeNavigationBarReducer"].thoughtSpotSettings,
    isEqual
  );
  if (currentUser && currentUser.userId > 0) {
    Cookie.set("MDAUDIT_AUTH_PROVIDER", currentUser.authProvider);
  }
  const mdaeNavigationBarDrawerConfig = useMemo(() => {
    const config: IMdaeDrawerOption = {
      id: "pnlNavbarDrawer",
      revealMode: "expand",
      openedStateMode: "shrink",
      template: "listTemplate",
      minSize: 80,
      maxSize: 280,
      mdaeDataUpdaterConfig: [
        {
          actionType: SET_MDAE_NAVIGATION_BAR_CONFIG,
          reducerName: "mdaeNavigationBarReducer",
          widgetOptionBindings: {
            opened: "isMdaeNavigationBarExpanded",
            height: "mdaeNavigationBarDrawerHeight",
          },
        },
      ],
    };
    return config;
  }, []);

  const isExternalUser = useMemo(
    () => hasAnyFeatureGroupAccess([FG_EXTERNAL_USER_TASK_EDITING], currentUser),
    [currentUser]
  );

  useEffect(() => {
    if (currentUser !== undefined && currentUser.userId > 0) {
      let uMenu;
      if (currentUser.clientId > 0 && !currentUser.isClientGroup) {
        if (props.isAnalyticsTheme) {
          uMenu = $.grep(currentUser.userPermissions.userMenu, function(
            e: any
          ) {
            return e.parentName === "Analytics";
          });
        } else if (props.isEatTheme) {
          uMenu = $.grep(currentUser.userPermissions.userMenu, function(
            e: any
          ) {
            return e.parentName === "Payer Audit";
          });
        } else {
          uMenu = $.grep(currentUser.userPermissions.userMenu, function(
            e: any
          ) {
            return e.parentName === "Audit";
          });
        }
      } else {
        if (currentUser.isClientGroup) {
          uMenu = $.grep(currentUser.userPermissions.userMenu, function(
            e: any
          ) {
            return e.parentName === "Aggregator Admin";
          });
        } else {
          uMenu = currentUser.userPermissions.userMenu;
        }
      }
      const hasHospitalWorkFlowEnabled = hasWorkflowAccess(
        [HOSPITAL_WORKFLOW],
        currentUser
      );
      const hasProfessionalWorkFlowEnabled = hasWorkflowAccess(
        [PROFESSIONAL_WORKFLOW],
        currentUser
      );
      const conditionsForProcedureUtilizationMenuItems = {
        hasHospitalWorkFlowEnabled: hasHospitalWorkFlowEnabled,
        hasProfessionalWorkFlowEnabled: hasProfessionalWorkFlowEnabled,
        dataFeed837IEnableInd: currentUser.dataFeed837IEnableInd,
        dataFeed837PEnableInd: currentUser.dataFeed837PEnableInd,
        dataFeedNonEDIClaimsEnableInd:
          currentUser.dataFeedNonEDIClaimsEnableInd,
      }; 
      
      const mdaeNavigationBarItemList = mdaeNewNavigationBarConfig.processNewMenuItemListDataSource(        
        JSON.parse(JSON.stringify(uMenu)),
        thoughtSpotSettings?.baseUrl,
        thoughtSpotSettings?.secretKey,
        currentUser?.mdaiAIUserName,
        currentUser?.mdaiROUserName,
        currentUser?.mdaiEAUserName,
        currentUser?.mdaiPUUserName,
        currentUser?.mdaiROIUserName,
        currentUser?.isTaskHQAccessEnabled || !isExternalUser,
        thoughtSpotSettings?.adminUser,
        dispatch,
        props.history,
        conditionsForProcedureUtilizationMenuItems
      );
      dispatch({
        type: SET_MDAE_NAVIGATION_BAR_CONFIG,
        data: {
          mdaeNavigationBarItemList: mdaeNavigationBarItemList,
          mdaeFirstMenuObject: mdaeNavigationBarItemList[0],
          mdaeNavigationBarDrawerHeight: window.innerHeight - 57,
          mdaeNavigationBarListWidth: 280,
          mdaePageContentLayoutHeight: window.innerHeight - 57 - 60,
          isMdaeNavigationBarExpanded:
            localStorage.getItem("is-mdae-navigation-bar-expanded") === "false"
              ? false
              : true,
        },
      });
    }
  }, [currentUser,thoughtSpotSettings, dispatch]);

  useEffect(() => {
      dispatch(actions.asyncOperationStart(GET_CURRENT_USER, {}));
      dispatch(actions.asyncOperationStart(GET_APPLICATION_CONFIGURATIONS, {}));
      dispatch(actions.asyncOperationStart(GET_THOUGHT_SPOT_SETTINGS, {}));
      dispatch(actions.asyncOperationStart(GET_CLIENT_LIST, {}));

    const resizeHandler = () => {
      const mdaeNavigationBarDrawerHeight = window.innerHeight - 57;
      const mdaePageContentLayoutHeight = window.innerHeight - 57 - 60;
      dispatch({
        type: SET_MDAE_NAVIGATION_BAR_CONFIG,
        data: {
          mdaeNavigationBarDrawerHeight: mdaeNavigationBarDrawerHeight,
          mdaePageContentLayoutHeight: mdaePageContentLayoutHeight,
        },
      });
    };
    $(window).on("resize", resizeHandler);
    return () => {
      $(window).off("resize", resizeHandler);
    };
  }, []);

  let CustomPageTitleComponent = null;
  for (var prop in pageCustomTitleBarConfig) {
    if (
      mdaeNewNavigationBarConfig.isCurrentURL(
        props.history?.location?.pathname,
        prop,
        false
      )
    ) {
      CustomPageTitleComponent = pageCustomTitleBarConfig[prop];
    }    
  }
  
  return (
    <div>
      <MdaeDrawer {...mdaeNavigationBarDrawerConfig}>
        <Template
          name="listTemplate"
          render={() => {
            return (
              <MdaeDrawerMenuListTemplate
                history={props.history}
                mdaeNavigationBarListWidth={mdaeNavigationBarListWidth}
                mdaePageTitle={mdaePageTitle}
              ></MdaeDrawerMenuListTemplate>
            );
          }}
        />
        <div>
          <div className="mdae-page-title audits-tab-section">
            {typeof CustomPageTitleComponent === "function" && (
              <CustomPageTitleComponent />
            )}
            {typeof CustomPageTitleComponent !== "function" && (
              <div className="content" style={{ display: "flex" }}>
                {mdaePageTitle}
              </div>
            )}           
          </div>
          <div
            id="pnlMdaePageContainerScrollViewContainer"
            style={{
              backgroundColor: "#E5E5E5 !important",
              height: window.innerHeight - 57 - 60 + "px",
            }}
          >
            <MdaeScrollView
              id="pnlMdaePageContainerScrollView"
              mdaeDataUpdaterConfig={[
                {
                  actionType: SET_MDAE_NAVIGATION_BAR_CONFIG,
                  reducerName: "mdaeNavigationBarReducer",
                  widgetOptionBindings: {
                    height: "mdaePageContentLayoutHeight",
                  },
                },
              ]}
            >
              <div className="menu-content-container">
                <div className="md-page-container">
                  {props.children}
                  <div className="page-footer">
                    <p className="no-s">
                      <span>
                        &copy; {new Date().getFullYear()} All rights reserved.
                        MDaudit is a registered trademark of Hayes Management
                        Consulting.
                      </span>
                      <span style={{ fontWeight: "bold", fontSize: "15px" }}>
                        |
                      </span>
                      <span>
                        <a
                          href="https://www.mdaudit.com/privacy-policy/"
                          target="_blank"
                        >
                          Privacy Policy
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </MdaeScrollView>
          </div>
        </div>
      </MdaeDrawer>
    </div>
  );
};
export default MdaeNavigationBar;
